<template>
  <div id="record">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl()">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        时间银行
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <div class="right" @click="toHome()" >
        <van-icon name="wap-home" size="21"/>
      </div>
    </div>
    <div class="padding content">
      <div class="main-content">
        <p class="section-title">时间银行</p>
        <p class="section-item">" 时间银行 " 居家养老志愿服务项目是东湖区从 2017 年 10 月开始在百花洲街道积极试点推行的居家养老全新模式</p>
        <p
          class="section-item"
        >所谓 " 时间银行 "，即借鉴商业银行的储蓄模式和管理方式，鼓励低龄老人和其他志愿者为社区高龄老人提供志愿服务，服务时长可以储存，未来需要别人向自己提供服务时，再用这些储存的时间进行兑换。低龄存时间，高龄取服务。东湖区的 " 时间银行 " 为社区老年人逐步认识并接受，辖区出现了越来越多为老年服务的志愿者。通过 " 时间银行 " 养老服务，达到了既为当下高龄、失能、失智和特殊群体老人提供养老服务，又为以后低龄老人养老打下基础的既定目的，实现社区居家养老服务的可持续发展。</p>
        <p
          class="section-item"
        >" 时间银行 " 居家养老模式通过政府搭台、社会参与、居民互助，以社区为基础，吸收低龄老人和志愿者，挖掘和发挥他们的空闲时间和专业技能，为高龄老人提供养老服务，推动形成低龄老人帮助老龄老人的互助养老新格局，形成了 " 提供养老服务——量化为时间储存——支取养老服务 " 的良性循环，在解决居民养老现实困境上发挥了重要作用。</p>
        <p
          class="section-item"
        >为保障 " 时间银行 " 正常有效的运行，按照 " 政府提供一些、社会捐助一些 " 的思路，东湖区设立 " 时间银行 " 公益基金。公益基金主要用于建设 " 时间银行 " 爱心超市、" 时间银行 " 互助服务公益项目、购买 " 时间银行 " 供兑换的物品、配备志愿服务者装备（比如服务记录仪）、志愿服务者教育培训、优秀志愿者奖励等。</p>
        <img class="img-responsive" src="@/assets/bank_content01.jpg" alt />
        <img class="img-responsive" src="@/assets/bank_content02.png" alt />
        <img class="img-responsive" src="@/assets/bank_qrcode.jpg" alt />
      </div>
    </div>
  </div>
</template>
<script>
import { Icon, Field } from "vant";
import { wantMenu } from "@/api/apiData";
import { formatDate } from "@/public/getFormatDate.js";
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
  },
  data() {
    return {
      info: [],
      type: "",
    };
  },
  filters: {
    //方法一: yyyy-MM-dd hh:mm
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      console.log(date);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  mounted() {
    let type = this.$route.query.type;
    this.type = type;
  },
  methods: {
    toUrl() {
      this.$router.go(-1);
    },
    toHome() {
      // this.$router.push("/index");
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
    },
    toGuide(t) {
      this.$router.push({
        path: "/helpForm",
        query: {
          type: t,
        },
      });
    },
    toDonate() {
      this.$router.push("/helpDonate");
    },
    toVolunteer(t) {
      this.$router.push({
        path: "/helpVolunteer",
        query: {
          type: t,
        },
      });
    },
  },
};
</script>
<style scoped>
.info-tit {
  font-weight: bold;
}
.content {
  width: 90%;
  margin: 0 auto;
  /* padding-top: 1rem; */
  /* margin-top: 10%; */
  text-align: left;
}
.info-tit {
  font-weight: bold;
  font-size: 1.2rem;
  margin: 1rem 0;
}
.info-time {
  font-size: 0.9rem;
  color: gray;
}
.info-time span {
  color: #72b550;
  margin-right: 1rem;
}
.infos {
  font-size: 1rem;
  text-indent: 2rem;
}
.info-img {
  text-align: center;
  margin: 1rem 0;
}
.info-img img {
  width: 80%;
  margin: 0 auto;
}
.list {
  border-bottom: solid 1px gainsboro;
  color: gray;
  padding: 1rem 0;
}
.main-content {
    padding: 5px 8px 8px;
    width: 100%;
}
.main-content .section-title {
    /* padding: 15px 0; */
    color: rgb(185,76,53);
    font-size: 16px;
    font-weight: 700;
}
.main-content .section-item {
    line-height: 1.8;
}
.img-responsive {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
}
</style>


// WEBPACK FOOTER //
// src/page/time.vue